module.exports = __webpack_public_path__ + "static/media/portal-logo.b53edebd.svg";